import { WIZARD_STEP_VALUES } from './resources';
import { StepNagivationOptions } from './types';

export function getNextStep(currentStep: WIZARD_STEP_VALUES, options: StepNagivationOptions): WIZARD_STEP_VALUES | null {
    let nextStep = null;
    switch (currentStep) {
        case WIZARD_STEP_VALUES.SELECT_SHEET:
            nextStep = WIZARD_STEP_VALUES.HEADER_MAPPING;
            break;
        case WIZARD_STEP_VALUES.HEADER_MAPPING:
            nextStep = options.duplicateExist ? WIZARD_STEP_VALUES.DUPLICATE_RECORDS : WIZARD_STEP_VALUES.PREVIEW;
            break;
        case WIZARD_STEP_VALUES.DUPLICATE_RECORDS:
            nextStep = WIZARD_STEP_VALUES.PREVIEW;
            break;
        default:
            break;
    }
    return nextStep;
}

export function getPrevStep(currentStep: WIZARD_STEP_VALUES, options: StepNagivationOptions): WIZARD_STEP_VALUES {
    let prevStep = WIZARD_STEP_VALUES.SELECT_SHEET;
    switch (currentStep) {
        case WIZARD_STEP_VALUES.HEADER_MAPPING:
            prevStep = WIZARD_STEP_VALUES.SELECT_SHEET;
            break;
        case WIZARD_STEP_VALUES.DUPLICATE_RECORDS:
            prevStep = WIZARD_STEP_VALUES.HEADER_MAPPING;
            break;
        case WIZARD_STEP_VALUES.PREVIEW:
            prevStep = options.duplicateExist ? WIZARD_STEP_VALUES.DUPLICATE_RECORDS : WIZARD_STEP_VALUES.HEADER_MAPPING;
            break;
        default:
            break;
    }
    return prevStep;
}
